import { Radar, ScanLine } from "lucide-react";
import { useEffect, useState } from "react";

const STAGES = [
  "RSI · MACD Kontrol Ediliyor",
  "Hacim Kontrol Ediliyor",
  "Web Detaylı Araştırma Yapılıyor",
  "Coin Derin Analiz Yapılıyor",
  "EMA Kontrol Ediliyor",
  "Uyumsuzluklar Aranıyor",
];

export default function LoadingOverlay() {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setStage((s) => (s + 1) % STAGES.length), 1600);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      data-testid="analysis-loading-overlay"
      className="fixed inset-0 z-50 flex items-center justify-center px-4 backdrop-blur-md"
      style={{ background: "rgba(7,10,16,0.88)" }}
    >
      <div className="text-center max-w-sm w-full">
        <div className="relative w-28 h-28 mx-auto mb-8">
          <div className="absolute inset-0 rounded-full border-2 border-blue-500/20" />
          <div className="absolute inset-0 rounded-full border-t-2 border-blue-500 spin-slow" />
          <div className="absolute inset-0 flex items-center justify-center">
            <Radar className="w-12 h-12 text-blue-500 pulse-glow" />
          </div>
        </div>
        <h2 className="text-2xl font-extrabold tracking-tight mb-2">Grafikler analiz ediliyor...</h2>
        <p className="text-sm mb-7" style={{ color: "var(--text-secondary)" }}>
          Çoklu zaman dilimi ve tüm grafikler birlikte değerlendiriliyor
        </p>
        <div className="space-y-2.5 text-left">
          {STAGES.map((s, i) => (
            <div
              key={s}
              className="flex items-center gap-3 text-sm px-4 py-2.5 rounded-xl border transition-all"
              style={{
                borderColor: i <= stage ? "rgba(59,130,246,0.4)" : "var(--border-subtle)",
                background: i <= stage ? "rgba(59,130,246,0.08)" : "transparent",
                color: i <= stage ? "var(--text-primary)" : "var(--text-muted)",
              }}
            >
              <ScanLine className={`w-4 h-4 ${i === stage ? "text-blue-500 pulse-glow" : i < stage ? "text-emerald-500" : ""}`} />
              {s}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
